import { FC, ReactElement } from 'react';

import { Page } from '../../../components';
import { ConnectedProductCategoryRenderer, ConnectedProductCategoryWrapper, ConnectedProductList } from '../../../connectors';
import { MeilisearchAttribute } from '../../../entities/@api/Meilisearch';
import { MeilisearchStoreKey } from '../../../entities/@search/Meilisearch/Meilisearch';
import { inStockSort } from '../../../entities/Sort/Sort';

import './ProductCategoryPage.scss';

export const ProductCategoryPage: FC = (): ReactElement => {
    const categories = [MeilisearchAttribute.categories];

    return (
        <ConnectedProductCategoryWrapper>
            {({ baseFilter, childCategories, callToActions }) => (
                <Page className="product-category-page">
                    <ConnectedProductCategoryRenderer>
                        {baseFilter && (
                            <ConnectedProductList
                                showFilterBar
                                storeKey={MeilisearchStoreKey.productCategory}
                                baseFilter={baseFilter}
                                baseSort={inStockSort}
                                hiddenFilterAttributes={childCategories.length === 0 ? categories : []}
                                childCategories={childCategories}
                                callToActions={callToActions}
                                className="product-category-page__product-list"
                            />
                        )}
                    </ConnectedProductCategoryRenderer>
                </Page>
            )}
        </ConnectedProductCategoryWrapper>
    );
};
